export enum UserAccessManagementStatus {
  PENDING = "pending",
  NOT_FOUND = "not_found",
  NOT_GRANTED = "not_granted",
  GRANTED = "granted",
  UNDEFINED = "undefined"
}
